import { render, staticRenderFns } from "./mailings-input-source.vue?vue&type=template&id=12099a63&"
import script from "./mailings-input-source.vue?vue&type=script&lang=js&"
export * from "./mailings-input-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports